define('mustache-language/lib/Translator',['require','exports','module','./Tokenizer','../dictionary','./locale'],function(require,exports,module){
    var Tokenizer = require( "./Tokenizer" ),
        languages = require( "../dictionary" ),
        localeParse = require( "./locale" );

    var empty = {},
        UNDEF,
        RE_CAP = /\b([\w])/g;

    var textDecoder = document.createElement('textarea');

    function decodeEntities(str){
        textDecoder.innerHTML = str || '';
        return textDecoder.innerHTML;
    }
    function capitalizeHelper ($0, $1){
        return $1.toUpperCase();
    }
    function capitalize(str){
        str.replace(RE_CAP,capitalizeHelper);
    }

    function Translator(lang, decode){
        var locale,
            dictionary,
            cache,
            translate,
            translator = this;

        this.cache = cache = {};
        this.locale = locale = localeParse(lang);
        dictionary = languages.get(lang);

        this.language = dictionary.code;

        this.dictionary = dictionary.dictionary;

        translate = this.translate = function(key, values){
            // console.trace();
            key = key || translator.key;
            // console.warn('translate', translator);
            if(key === UNDEF){
                return key;
            }
            var tokenizer   = cache[key] || (cache[key] = new Tokenizer(key)),
                looseKey     = dictionary.hash[tokenizer.lowerKey],
                translated  = dictionary.dictionary[tokenizer.key] || dictionary.dictionary[looseKey];

            return tokenizer.replace(translated, values);
        };  

        if(decode === true){
            var raw = translate;
            translate = this.translate = function(key, values){
                return decodeEntities(raw(key, values));
            };
        }
        this.translateCapitalize = function(key){
            return capitalize(translate(key));
        }

        this.translateLowerCase = function(key){
            return translate(key).toLowerCase();
        }

        this.translateUpperCase = function(key){
            console.log('upper',translator,arguments);
            return translate(key).toUpperCase();
        }

    };

    Translator.prototype.languages = languages;
    Translator.prototype.decode = function(str){
        return decodeEntities(str);
    };
    return Translator;
});
